import React, {useEffect} from "react";
import { useStyles } from "../styles/EvenDialogueTranslationStyle";
import { Box, Button, Typography, TextField, Switch, FormControlLabel } from "@material-ui/core";
import clsx from "clsx";
import { withRouter } from "react-router-dom";
import EduLangTabs from "../../../../../../components/EduLangTabs";
import { inject, observer } from "mobx-react";
import { ReactComponent as Refresh } from '../../../../../../common/images/Refresh.svg';
import {TranslationLangName} from "../../../../../../common/enums/ContentEnum";

function EvenStepTwo(props) {
    const classes = useStyles();

    const { contentStore, evenStepTwoStore } = props;
    const { contentTapIndex, selectedContent, translationContents } = evenStepTwoStore;

    useEffect(() => {
        evenStepTwoStore.getEvenStepTwoContent(contentStore.stepValue, contentStore.dayValue);
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
            evenStepTwoStore.initEvenStepTwoContent(contentStore.stepValue, contentStore.dayValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSave = () => {
        evenStepTwoStore.modifyEvenStepTwoContent(contentStore.stepValue, contentStore.dayValue);
    }

    const handleTabChange = (event, newValue) => {
        evenStepTwoStore.setContentTapIndex(newValue);
    };

    const handleChangeSwitch = (e, targetLang) => {
        evenStepTwoStore.setTranslateDisplay(e.target.checked, targetLang);
    };

    const handleChangeTranslate = (e, index, lang) => {
        evenStepTwoStore.setTranslateText(e.target.value, index, lang);
    }

    return (
        <div className={classes.root}>
            <Box className={clsx(classes.boxWrap, classes.heightStep3)}>
                    <EduLangTabs value={contentTapIndex} handleChange={handleTabChange}/>
                    <Box className={classes.textBox}>
                        <Box className={classes.ListBox}>
                            {!!selectedContent.length && selectedContent.map((content, i) => (
                                <Box display={'flex'}
                                     alignItems={'center'}
                                     justifyContent={'flex-start'}
                                     key={i}
                                     className={classes.nameList}>
                                    <Typography>{content.speakerName}</Typography>
                                    <Box className={classes.fullTextListBox} variant="contained" color="primary" >
                                        <Typography>{content.text}</Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
            </Box>
            <Box className={clsx(classes.boxWrap, classes.heightStep3)} sx={{marginTop: 20}}>
                {Object.keys(translationContents).map((translation, i) => {
                    return (
                        <div key={i}>
                            <Box display={'flex'} justifyContent={'space-between'} className={classes.SpeakinWritingTitle}>
                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    <Typography className={classes.langText}>{TranslationLangName[translation]}</Typography>
                                    <Button disableRipple onClick={() => evenStepTwoStore.getAiTranslate(translation)}>
                                        <Refresh />
                                    </Button>
                                </Box>
                                <Box>
                                    <FormControlLabel
                                        control={<Switch checked={translationContents[translation].some(c => c.enable)}
                                                         onChange={(e) => handleChangeSwitch(e, translation)}
                                                         className={classes.swichStyle} />}
                                        label="앱 노출"
                                        labelPlacement="start"
                                    />
                                </Box>
                            </Box>
                            <Box className={classes.ListBox}>
                                {!!translationContents[translation].length &&
                                translationContents[translation].map((content, j) => (
                                    <Box
                                        display={'flex'}
                                        alignItems={'center'}
                                        justifyContent={'flex-start'}
                                        key={content.id}
                                        className={clsx(classes.textFieldBox, classes.nameList)}
                                    >
                                        <Typography>{content.speakerName}</Typography>
                                        <TextField id="outlined-basic"
                                                   variant="outlined"
                                                   onChange={(e) => handleChangeTranslate(e, j, translation)}
                                                   placeholder="번역문을 입력해주세요."
                                                   value={content.text}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </div>
                    );
                })}
            </Box>
        </div>
    );
}

export default withRouter(inject('contentStore','evenStepTwoStore')(observer(EvenStepTwo)));
